import { getWatermarkedImgixUrl, isValidImageReference } from "services";
import { PROPERTY_TYPE } from "../../../propertyListingV2/constants/auction";

// TODO: Data transformation, what is it frontend dependent? This should be moved to the backend while we are doing Typesense indexing. So that most of the transformation is at one place. Plan for it to move to the backend.
export const transformPrivateProperties = (properties: any[]) => {
  return properties?.map((property: any) => {
    const basePrice =
      property?.reserve_price !== 0
        ? property?.reserve_price
        : property?.posted_properties_data?.base_price_proposed_last_rp
        ? property?.posted_properties_data?.base_price_proposed_last_rp
        : property?.posted_properties_raw_data?.propertyCost;

    const area = getPrivatePropertyArea(property);

    const tagRelatedData = {
      isTagged: property?.interested_count > 0,
      tag: undefined,
      showTagText: true,
      tagText: property?.interested_count
        ? `${property?.interested_count}+ people shortlist this property`
        : undefined,
    };

    const sellerRelatedData = {
      bankName: property?.dump.bank.bank_name,
      bankLogo: property?.dump?.bank?.bank_logo
        ? `${process.env.NEXT_PUBLIC_IMAGIX_URL}/${property?.dump?.bank?.bank_logo}?w=32&h=32&auto=format`
        : undefined,
    };

    const imageIdFromPostedPropertyArray =
      property?.posted_properties_raw_data?.propertyPhotos?.[0]?.id;
    const imageFromDumpData = property?.dump?.property_image;
    const imageFromDumpAssetData = property?.dump?.asset?.placeholder_image;
    const imageUuid =
      imageIdFromPostedPropertyArray ||
      imageFromDumpData ||
      imageFromDumpAssetData;

    const propertyImageUrl = imageUuid
      ? getWatermarkedImgixUrl(
          `${process.env.NEXT_PUBLIC_IMAGIX_URL}/${imageUuid}`,
        )
      : "";

    const hasImage = isValidImageReference(propertyImageUrl);

    const imageRelatedData = {
      hasImage: hasImage,
      propertyImageUrl: propertyImageUrl,
      showRequestImagesCta: !imageIdFromPostedPropertyArray,
    };

    return {
      propertyType: PROPERTY_TYPE.PRIATE,
      listingId: property?.listing_id,
      title: `${property?.dump?.asset?.sub_asset_type_name} in ${property?.dump?.location?.city_name}`,
      priceTag: "Base Price",
      price: basePrice,
      area,
      ...imageRelatedData,
      ...tagRelatedData,
      ...sellerRelatedData,
      isVerified: property?.ab_verified,
      isLiked: false,
    };
  });
};

export const getPrivatePropertyArea = (propertyData: any) => {
  const raw = propertyData?.posted_properties_raw_data;

  const builtUp = raw?.builtUpArea;
  const carpet = raw?.carpetArea;

  const isValid = (val: any) =>
    val !== null &&
    val !== undefined &&
    val !== "" &&
    !isNaN(val) &&
    Number(val) > 0;

  let area = null;

  if (isValid(builtUp)) {
    area = builtUp;
  } else if (isValid(carpet)) {
    area = carpet;
  }

  return area ? `${area} sq. ft` : "NA";
};
